import moment from 'moment';

// Action Types
export enum Types {
  LOAD_OPEN_ORDER_STATUS = 'dashboard/LOAD_OPEN_ORDER_STATUS',
  LOAD_OPEN_ORDER_STATUS_SUCCESS = 'dashboard/LOAD_OPEN_ORDER_STATUS_SUCCESS',
  LOAD_OPEN_ORDER_STATUS_FAILURE = 'dashboard/LOAD_OPEN_ORDER_STATUS_FAILURE',
  LOAD_OPEN_ORDER_STATUS_BY_SKU = 'dashboard/LOAD_OPEN_ORDER_STATUS_BY_SKU',
  LOAD_OPEN_ORDER_STATUS_BY_SKU_SUCCESS = 'dashboard/LOAD_OPEN_ORDER_STATUS_BY_SKU_SUCCESS',
  LOAD_OPEN_ORDER_STATUS_BY_SKU_FAILURE = 'dashboard/LOAD_OPEN_ORDER_STATUS_BY_SKU_FAILURE',

  LOAD_BILLED_BY_MONTH = 'dashboard/LOAD_BILLED_BY_MONTH',
  LOAD_BILLED_BY_MONTH_SUCCESS = 'dashboard/LOAD_BILLED_BY_MONTH_SUCCESS',
  LOAD_BILLED_BY_MONTH_FAILURE = 'dashboard/LOAD_BILLED_BY_MONTH_FAILURE',

  LOAD_PAID_BY_MONTH = 'dashboard/LOAD_PAID_BY_MONTH',
  LOAD_PAID_BY_MONTH_SUCCESS = 'dashboard/LOAD_PAID_BY_MONTH_SUCCESS',
  LOAD_PAID_BY_MONTH_FAILURE = 'dashboard/LOAD_PAID_BY_MONTH_FAILURE',

  LOAD_DUPLICATES = 'dashboard/LOAD_DUPLICATES',
  LOAD_DUPLICATES_SUCCESS = 'dashboard/LOAD_DUPLICATES_SUCCESS',
  LOAD_DUPLICATES_FAILURE = 'dashboard/LOAD_DUPLICATES_FAILURE',

  LOAD_BILLED_BY_DAY = 'dashboard/LOAD_BILLED_BY_DAY',
  LOAD_BILLED_BY_DAY_SUCCESS = 'dashboard/LOAD_BILLED_BY_DAY_SUCCESS',
  LOAD_BILLED_BY_DAY_FAILURE = 'dashboard/LOAD_BILLED_BY_DAY_FAILURE',

  LOAD_DUPLICATES_BY_DAY = 'dashboard/LOAD_DUPLICATES_BY_DAY',
  LOAD_DUPLICATES_BY_DAY_SUCCESS = 'dashboard/LOAD_DUPLICATES_BY_DAY_SUCCESS',
  LOAD_DUPLICATES_BY_DAY_FAILURE = 'dashboard/LOAD_DUPLICATES_BY_DAY_FAILURE',

  CLEAN_DASHBOARD = 'dashboard/CLEAN_DASHBOARD'
}

export interface IDashboardState {
  selectedCustomerId: string;

  openOrderStatus?: IOpenOrderStatusState;
  billedByMonth?: IBilledByMonthState;
  paidByMonth?: IPaidByMonthState;
  duplicates?: IDuplicateState;
  billedByDay?: IBilledByDayState;
  duplicatesByDay?: IDuplicatesByDayState;
}

export interface IOpenOrderStatusState {
  loading: boolean;
  error: boolean;

  loadingBySku?: boolean;
  erroBySku?: boolean;
  lastUpdateMomentBySku?: moment.Moment | undefined;

  lastUpdateMoment?: moment.Moment | undefined;
  dashboard?: IOpenOrderStatusData[];
  dashboardBySku?: IOpenOrderStatusDataBySku[];
}

export interface IOpenOrderStatusData {
  division: string;
  divisionProducts: string;
  totalDelivery: string;
  totalPending: string;
  totalRequested: string;
  totalShipment: string;
}

export interface IOpenOrderStatusDataBySku {
  product: number;
  productDescription: string;
  totalDelivery: string;
  totalPending: string;
  totalRequested: string;
  totalShipment: string;
}

export interface IBilledByMonthState {
  loading: boolean;
  error: boolean;
  data: IBilledMonthData[];
}

export interface IBilledMonthData {
  total?: number;
  type?: string;
  date: string;
}

export interface IPaidByMonthState {
  loading: boolean;
  error: boolean;
  data: IPaidByMonthData[];
}

export interface IPaidByMonthData {
  invoicesSummary: {
    totalInvoice?: string;
    date: string;
  };
}

export interface IDuplicateState {
  loading: boolean;
  error: boolean;
  invoicesSummary?: IDuplicateData;
}
export interface IDuplicateData {
  dueInvoiceSum: string;
  openInvoiceSum: string;
  totalInvoice: string;
}

export interface IBilledByDayState {
  loading: boolean;
  error: boolean;
  data: IBilledByDayData[];
  monthDate: moment.Moment;
}
export interface IBilledByDayData {
  date: string;
  products: IBilledByDayProduct[];
}
export interface IBilledByDayProduct {
  division: string;
  divisionDescription: string;
  billedToday: number;
}

export interface IDuplicatesByDayState {
  loading: boolean;
  error: boolean;
  data: IDuplicatesByDayData[];
  monthDate: moment.Moment;
}

export interface IDuplicatesByDayData {
  date: string;
  duplicates: IDuplicateByDay[];
}
export interface IDuplicateByDay {
  status: string;
  totalInvoice: number;
}
